import { QuoteItemTypeCodeName } from '@lio/rule-engine';
import { QuoteItem } from '@store/Quote/Quote.types';

export const resolveQuoteItemJurisdictionId = (
  quoteItem: QuoteItem | undefined,
  quoteItems: QuoteItem[],
): string | undefined => {
  let current = quoteItem;

  while (current) {
    if (current.quoteItemType.codeName === QuoteItemTypeCodeName.Jurisdiction) {
      return current.attributeTypes.JurisdictionId?.attribute?.value as string | undefined;
    }
    current = quoteItems.find((qi) => qi.id === current?.parentId);
  }

  return undefined;
};
